module.exports = __webpack_public_path__ + "static/media/close.0730f0a2.png";